import React, { useCallback } from 'react';

import i18n from '@nextroll/ar-i18n';

import { ExpandablePanel } from './ExpandablePanel';


// hardcode for the alpha release; may be fetched from an API in the future
const ACCOUNT_BASED_ACTION_CONTACT_FILTER_SENIORITIES = {
    Cxo: 'C-Level',
    Vp: 'VP-Level',
    Director: 'Director',
    Manager: 'Manager',
    Staff: 'Non-Manager',
};

export const ExpandablePanelSeniorityFilter = ({ filters, setFilters }: {
    filters: string[];
    setFilters: (filters: string[]) => void;
}) => {
    const handleCheck = useCallback((item: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.checked) {
            setFilters([...filters, item]);
            return;
        }
        setFilters([...filters].filter(i => i !== item));
    }, [filters, setFilters]);

    return (
        <ExpandablePanel
            title={i18n.gettext('Seniority')}
            icon={<i className='fas fa-award' />}
            items={filters}
            setItems={setFilters}
        >
            {Object.entries(ACCOUNT_BASED_ACTION_CONTACT_FILTER_SENIORITIES).map(([seniority, label]) => (
                <span key={`filter-seniority-checkbox-${seniority}`}>
                    <input
                        type='checkbox'
                        id={`filter-seniority-checkbox-${seniority}`}
                        name='filter-seniority-checkbox'
                        checked={filters.includes(seniority)}
                        onChange={handleCheck(seniority)}
                        className='ar-checkbox'
                    />
                    <label htmlFor={`filter-seniority-checkbox-${seniority}`}>
                        {label}
                    </label>
                </span>
            ))}
        </ExpandablePanel>
    );
};
